module.exports = __webpack_public_path__ + "de72461f14e63934c813505a839b7085.png";